import firebase from 'firebase'

export const uiConfig = {
  signInFlow: 'popup',
  signInSuccessUrl: '/auth',
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID
  ]
}
